import React, { useEffect, useState } from "react";
import "./index.css";
import { Table } from "reactstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  getExpenseWalletSummary,
  getSalaryWalletDetails,
  cleanSalaryWalletDetails,
  getSalaryWalletList,
} from "../../../services/Store/Actions/driverslistActions";
import { useDispatch, useSelector } from "react-redux";
// import SearchBar from "../../../subComponents/searchbar";
// import ManageDriverDetailsCard from "../../../../Subcomponent/ManageDriverDetailsListCard";
// import ManageVehicleListBar from "../../../ManageVehicles/SubComponents/ManageVehicleListBar";
// import ManageDriverVehicleListBar from "../../../../Subcomponent/ManageDriverVehicleListBar";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import SvgImage from "../../Icons/Icons";
import { storeDataToAsyncStorage } from "../../../services/Utils/functions";

const DriverList = (props) => {
  const [offset, setOffset] = useState(0);
  const { showingModal, openVKyc } = props;
  const [search, setSearch] = useState("");
  const [fetchMoreData, setFetchMoreData] = useState(true);
  const [rcolor, setRColor] = useState(-1);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { salaryWallets, salaryWalletsCount } = useSelector(
    (state) => state?.driverlist
  );
  console.log("lenthe hereeeeeeeeeeeee", salaryWallets);

  const handlePrevButton = () => {
    if (props.offset > 0) {
      props.nextTrigger();
      props.setOffset(props.offset - 15);
      console.log("offset", props.offset);
      dispatch(
        getSalaryWalletList({
          offset: props.offset - 15,
          search: props.search.trim(),
          sortAs: "",
          sortBy: "",
        })
      );
    }
    //props.allowTrigger();
    console.log("X--");
  };
  const handleNextButton = () => {
    //props.nextTrigger();
    if (salaryWalletsCount - props.offset > 15) {
      props.nextTrigger();
      props.setOffset(props.offset + 15);
      console.log("offset", props.offset);
      dispatch(
        getSalaryWalletList({
          offset: props.offset + 15,
          search: props.search.trim(),
          sortAs: "",
          sortBy: "",
        })
      );
    }
    //props.allowTrigger();
    console.log("X++");
  };
  const { expenseWalletSummaryList } = useSelector(
    (state) => state?.driverlist
  );

  const handleClick = (e, i) => {
    if (e.phone == id) {
    } else {
      props.allowTrigger();
      // console.log(
      //   "drivers ki list",
      //   `/Salary/${e.User.userId}?search=${props.search}&offset=${props.offset}`
      // );
      dispatch(cleanSalaryWalletDetails());
      // dispatch(getSalaryWalletDetails({phone: e?.phone}));
      // dispatch(getExpenseWalletSummary(e?.User?.userId, {isSalaryWallet:1}))
      // console.log('heeeeeeeeeeeerrrrrrrrrrrrrrrrrrrrr', expenseWalletSummaryList);
      // storeDataToAsyncStorage("_driverId", e.User.driverId);
      navigate(`/salary/${e.phone}`);
    }
  };

  let { id } = useParams();

  useEffect(() => {
    let urlId = window.location.pathname.split("/");

    if (urlId.length === 3) {
      if (urlId[2] != undefined && urlId[2] != "") {
        let i = salaryWallets.findIndex((element) => element.phone == urlId[2]);

        setRColor(i);
      }
    }
  }, [id, salaryWallets]);

  return (
    <div className="main-all-customer-list">
      <div id="scrollableDivCustomer" className="div-table">
        {/* <div className="div-table-row">
          <div className="listHeaderCont">
            <div className="div-table-col width50 FontBold"> Driver Name</div>

            <div class="div-table-col width50 FontBold"> Total Balance</div>
          </div>
        </div> */}
        <div className="div-table-row">
          <div
            className="listHeaderContSalary row"
            style={{ textAlign: "center", padding: "10px" }}
          >
            <div className="col-6 FontBold">Driver Name</div>
            <div class="col-6 FontBold">Phone</div>
          </div>
        </div>

        {salaryWallets?.map((data, i) => {
          console.log(data);

          let color = " ";
          const trimmedName = data.fullName.trim();
          const driverSalary = data?.salary;
          const name = trimmedName.split(" ");
          const d = {
            firstName: name[0],
            lastName: name[name.length - 1],
          };
          const firstName_initials = d.firstName[0];
          const lastName_initials = d.lastName[0] + ".";
          return (
            <div
              className={
                rcolor === i
                  ? "div-table-row actve-button-chosen-for-customer"
                  : "div-table-row"
              }
              key={i}
            >
              <div className="rowCont row" onClick={() => handleClick(data, i)}>
                <div class="div-table-col width50 FontNB" className="col-6">
                  <div data-letters={i + 1 + props.offset}>
                    <span className=" FontNB">
                      {d.firstName.length > 10
                        ? d.firstName.substring(0, 8) + ".."
                        : d.firstName}
                    </span>
                    <span className="FontNB">
                      {" "}
                      {lastName_initials.toUpperCase()}
                    </span>
                  </div>
                  <div
                    className={
                      driverSalary === ""
                        ? "nameSubInfo FontSmall"
                        : "nameSubInfo FontSmall"
                    }
                    style={
                      driverSalary === ""
                        ? { color: "#E63946", cursor: "pointer" }
                        : {}
                    }
                  >
                    {/* {data?.User?.fleet === null
                      ? "no vehicle"
                      : data?.User?.fleet} */}
                    {"Salary: ₹"}
                    {driverSalary}
                  </div>
                </div>
                <div
                  class="div-table-col width50 FontNB"
                  className="col-6"
                  style={{ textAlign: "center" }}
                >
                  <div>
                    <span className=" FontNB">{data?.phone}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="nextRow ">
        <div className="nextRowCont ">
          <button
            className="PrevButton"
            onClick={handlePrevButton}
            style={{ opacity: props.offset > 0 ? "1" : "0.5" }}
          >
            <SvgImage name="PrevArrow" heigth="12px" width="12px" />
          </button>
          <button
            className="nextButton"
            onClick={handleNextButton}
            style={{
              opacity: salaryWalletsCount - props.offset > 15 ? "1" : "0.5",
            }}
          >
            <SvgImage name="NextArrow" heigth="12px" width="12px" />
          </button>
        </div>
      </div>
    </div>
  );
};
export default DriverList;
